export function selectAll(reducer){
    return reducer.App;
}